import { gsap } from "gsap";

export default el => {

	const items = [
		el,
		...el.querySelectorAll('.js-appear')
	];

	const tl = gsap.timeline();
	tl.to(
		items,
		{
			opacity: 1,
			y: 0,
			duration: 0.75, 
			stagger: {
        		each: 0.1,
        		ease: 'power2.inOut'
	    	},
	    	onStart: function() {
	    	    el.classList.add('appeared');
	    	}
		}
	);

	// items.forEach((item) => {

    // 	let dataDelay = item.dataset.appearDelay;
    	   
    // 	if (isNaN(dataDelay) || "" === dataDelay || null === dataDelay) {
    // 		dataDelay = 200;
    // 	}
    	
    // 	d += Number(dataDelay);

	
	//   	tl.fromTo(item, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.75 });
	//   	master.add(tl, d);
	// })

	// let delay = 0;

	// for (var j = 0; j < items.length; j++) {
	//     (function(j){ 

	//     	let dataDelay = items[j].dataset.appearDelay;
	    	   
	//     	if (isNaN(dataDelay) || "" === dataDelay || null === dataDelay) {
	//     		dataDelay = 200;
	//     	}
	    	
	//     	delay += Number(dataDelay);

	//     	setTimeout(function(){
	//     		items[j].classList.add('appeared');
	//     	}, delay);

	//     })(j);
	// }

	// el.classList.add('appeared');
};